export const portalLogoBrand = portal => {
  if (!portal) return 'default';
  if (['de', 'de_babies'].includes(portal)) return portal;
  if (!portal.startsWith('fr')) return 'inactive';
  return 'default';
};